var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34265_15683)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M43.5 22C43.5 33.8741 33.8741 43.5 22 43.5C10.1259 43.5 0.5 33.8741 0.5 22C0.5 10.1259 10.1259 0.5 22 0.5C33.8741 0.5 43.5 10.1259 43.5 22Z",
    stroke: "#7B63BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 36.4138C29.9605 36.4138 36.4138 29.9605 36.4138 22C36.4138 14.0395 29.9605 7.58618 22 7.58618C14.0395 7.58618 7.58618 14.0395 7.58618 22C7.58618 29.9605 14.0395 36.4138 22 36.4138Z",
    fill: "#5DC9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.865 27.3103C18.7565 27.3104 18.6491 27.2896 18.5493 27.2492C18.4495 27.2088 18.3594 27.1495 18.2843 27.0751L13.886 22.7293C13.8113 22.6572 13.7525 22.5717 13.7129 22.4779C13.6733 22.3841 13.6537 22.2837 13.6552 22.1826C13.6568 22.0816 13.6794 21.9818 13.7218 21.889C13.7643 21.7963 13.8256 21.7125 13.9024 21.6425C13.9792 21.5724 14.0698 21.5175 14.1691 21.481C14.2684 21.4444 14.3743 21.4269 14.4807 21.4295C14.5872 21.4321 14.692 21.4547 14.7892 21.496C14.8864 21.5373 14.974 21.5965 15.0469 21.6702L18.9064 25.4834L28.9964 16.8899C29.0749 16.8218 29.1669 16.7691 29.2669 16.7349C29.367 16.7006 29.4732 16.6856 29.5795 16.6906C29.6857 16.6956 29.7899 16.7205 29.8859 16.7639C29.9819 16.8073 30.0679 16.8684 30.139 16.9436C30.21 17.0187 30.2647 17.1065 30.2997 17.2018C30.3348 17.2972 30.3497 17.3982 30.3434 17.499C30.3371 17.5998 30.3099 17.6984 30.2633 17.7892C30.2166 17.8799 30.1515 17.961 30.0716 18.0277L19.4025 27.1145C19.255 27.2407 19.0635 27.3104 18.865 27.3103Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34265_15683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7b033a85d26b18ef59c2e23d1513a35b.svg";
export { ForwardRef as ReactComponent };